module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_vm._v("\r\n        © 2016 - 2019 Radar \r\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-676be1ca"}!./src/pages/MainFooter/template.html
// module id = 297
// module chunks = 0